import { render, staticRenderFns } from "./WidgetEntitySelector.vue?vue&type=template&id=8689ea4a"
import script from "./WidgetEntitySelector.vue?vue&type=script&lang=js"
export * from "./WidgetEntitySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports